// 在这里统一维护alslog 的f1内容
export default {
    // 首页
    // 访问账户数, show
    homeUv: 'homeUv',
    // 工作台,各个子页面UV,f11来源页route name
    pageUv: 'pageUv',

    // 文本创作
    // 工作台模板, click
    textWorkTemplate: 'textWorkTemplate',
    // 创作结果、历史、收藏, click
    textCreateTab: 'textCreateTab',
    // 收藏, click
    textCollectIcon: 'textCollectIcon',
    // 复制, click
    textCopyIcon: 'textCopyIcon',
    // 赞, click
    textLikeIcon: 'textLikeIcon',
    // 踩, click
    textDislikeIcon: 'textDislikeIcon',
    // 编辑, click
    textEditIcon: 'textEditIcon',
    // 提交编辑, submit
    textEditSubmit: 'textEditSubmit',
    // 清空按钮, click
    textClear: 'textClear',
    // 生成按钮，click
    textCreate: 'textCreate',
    // 历史列表筛选, query
    historyQuery: 'historyQuery',
    // 数字人下载，click
    aiDigitalDownload: 'aiDigitalDownload',
    // 脚本文案跳转数字人编辑器, click
    scriptToEditor: 'scriptToEditor',
    // 导入功能点击
    textImportIcon: 'textImportIcon',
    // 解析url
    textParseUrl: 'textParseUrl',
    // 解析url完成
    textParseUrlSuccess: 'textParseUrlSuccess',
    // 导入结果完成
    textImportSuccess: 'textImportSuccess',
    // 文案批量下载
    textCreateDownLoad: 'textCreateDownLoad',
    // resultHeader点击复用表单项
    reuseFormData: 'reuseFormData',
    // 偏好设置面板折叠展开
    preferPanel: 'preferPanel',
    // 业务设置面板折叠展开
    businessPanel: 'businessPanel',
    // 点击保存弹窗到文案库
    saveToast: 'saveToast',
    // 点击保存
    saveRecord: 'saveRecord',
    // 点击批量保存
    saveRecordBatch: 'saveRecordBatch',
    // 点击生成标题和描述
    geneDesc: 'geneDesc',

    // 图像生成
    // 工作台模板, click
    imageWorkTemplate: 'imageWorkTemplate',
    // 创作结果、历史、收藏, click
    imageCreateTab: 'imageCreateTab',
    // 图片生成单项结果，show
    imageCreateItemResult: 'imageCreateItemResult',
    // 图片生成单项编辑，click
    imageCreateItemEdit: 'imageCreateItemEdit',
    // 图片收藏，click
    imageCreateCollect: 'imageCreateCollect',
    // 图片批量收藏，click
    imageCreateBatchCollect: 'imageCreateBatchCollect',
    // 图片保存到图片库，click
    imageCreateAddImage: 'imageCreateAddImage',
    // 营销图，show
    imageCreatePoster: 'imageCreatePoster',
    // 营销图生成按钮，click
    imageCreatePosterGenerate: 'imageCreatePosterGenerate',
    // 图生图，show
    imageCreateImage: 'imageCreateImage',
    // 图生图生成按钮，click
    imageCreateImageGenerate: 'imageCreateImageGenerate',

    // 共拓
    // 共拓首页UV
    coExtensionHomeUV: 'coExtensionHomeUV',
    // 共拓首页-热门工具推荐点击
    coExtensionHomeTools: 'coExtensionHomeTools',
    // 申请接入
    coExtensionApply: 'coExtensionApply',
    // 共拓工具集页
    coExtensionMarketUV: 'coExtensionMarketUV',
    // 共拓工具集页-工具点击
    coExtensionMarketTool: 'coExtensionMarketTool',
    // 共拓工具集详情页UV
    coExtensionMarketDetailUV: 'coExtensionMarketDetailUV',

    // 进入口播文案
    entryTextCreate: 'entryTextCreate',
    // 进入数字人列表页
    entryDigicList: 'entryDigicList',
    // 进入任我的列表页
    entrydigitalMy: 'entrydigitalMy',
    // 进入数字人模板页
    entrydigitalVideoTemplate: 'entrydigitalVideoTemplate',

    // 数字人相关
    // 数字人首页
    digitalHome: 'digitalHome',
    // 数字人列表
    digitalHumanList: 'digitalHumanList',
    // 数字人定制类型卡片
    digitalHumanCard: 'digitalHumanCard',
    // 定制音色列表
    digitalVoiceList: 'digitalVoiceList',
    // 定制音色类型卡片
    digitalVoiceCard: 'digitalVoiceCard',
    // 定制音色上传页面
    digitalVoiceCreate: 'digitalVoiceCreate',
    // 数字人模板
    digitalTemplate: 'digitalTemplate',
    // 我的
    digitalMyVideo: 'digitalMyVideo',
    // 编辑器入口
    editorSource: 'editorSource',
    // 编辑器右侧操作区
    editorRightOperator: 'editorRightOperator',
    // 编辑器左侧Nav导航条
    editorNavEntry: 'editorNavEntry',
    // 编辑器左侧场景tab
    editorScenesTab: 'editorScenesTab',
    // 编辑器左侧数字人tab
    editorAipersonTab: 'editorAipersonTab',
    // 编辑器左侧模板tab
    editorTemplateTab: 'editorTemplateTab',
    // 编辑器左侧字幕tab
    editorCaptionTab: 'editorCaptionTab',
    // 编辑器左侧字幕样式
    editorCaptionTabStyle: 'editorCaptionTabStyle',
    // 编辑器左侧背景tab
    editorBkgTab: 'editorBkgTab',
    // 编辑器左侧素材tab
    editorMaterialTab: 'editorMaterialTab',
    // 编辑器左侧贴纸tab
    editorStickerTab: 'editorStickerTab',
    // 编辑器左侧图片tab
    editorPictureTab: 'editorPictureTab',
    // 编辑器左侧视频tab
    editorVideoTab: 'editorVideoTab',
    // 编辑器左侧音乐tab
    editorMusicTab: 'editorMusicTab',
    // 编辑器左侧花字tab
    editorFlowerTab: 'editorFlowerTab',
    // 编辑器左侧花字样式
    editorFlowerTabStyle: 'editorFlowerTabStyle',
    // 编辑器左侧文字模版tab
    editorTexttplTab: 'editorTexttplTab',
    // 编辑器左侧文字模版样式
    editorTexttplTabStyle: 'editorTexttplTabStyle',
    // 编辑器轨道按钮操作区
    trackControl: 'trackControl',

    // 生成式首页
    // query 发送
    aiFrontQuery: 'aiFrontQuery',
    // 重新生成
    aiFrontReGenerate: 'aiFrontReGenerate',
    // 停止生成
    aiFrontStopGenerate: 'aiFrontStopGenerate',
    // 去 图像生成、文本创作、数字人创作
    aiFrontRedirect: 'aiFrontRedirect',
    // 对话历史，点击
    aiFrontDialogHistory: 'aiFrontDialogHistory',
    // 展开创作结果
    aiFrontExpandResult: 'aiFrontExpandResult',
    // 创作结果，切换tab
    aiFrontResultTab: 'aiFrontResultTab',
    // 文本卡片
    aiFrontTextCopy: 'aiFrontTextCopy',
    aiFrontTextEdit: 'aiFrontTextEdit',
    aiFrontTextCancelEdit: 'aiFrontTextCancelEdit',
    // 图片卡片
    aiFrontImagePreview: 'aiFrontImagePreview',
    aiFrontImageSave: 'aiFrontImageSave',
    // 数字人卡片
    aiFrontVideoSave: 'aiFrontVideoSave',
    // 收藏
    aiFrontCollect: 'aiFrontCollect',
    // 反馈
    // 1:赞 2: 踩 3:取消赞 4：取消踩
    aiFrontFeedback: 'aiFrontFeedback',
    // 提交反馈弹窗
    aiFrontSubmitFeedback: 'aiFrontSubmitFeedback',
    // 关闭反馈弹窗
    aiFrontCancelFeedback: 'aiFrontCancelFeedback',

    // 帮助文档
    // 帮助文档入口—点击
    helpDoc: 'helpDoc',
    // 帮助文档访问
    helpDocAccess: 'helpDocAccess',
    // 帮助文档图片缩放
    helpDocImgZoom: 'helpDocImgZoom',
    // 导航点击
    helpDocNav: 'helpDocNav',
    // 帮助文档搜索
    helpDocSearch: 'helpDocSearch',
    // 帮助文档搜索结果点击
    helpDocSearchRedirect: 'helpDocSearchRedirect',
    // 导航栏展开收起
    helpDocNavFold: 'helpDocNavFold',
    // 锚点点击跳转
    helpDocAnchor: 'helpDocAnchor',
    // 平台反馈通路
    // 提交反馈：submit;点击反馈入口：click
    qingduoFeedback: 'qingduoFeedback',
    // 取消反馈,click
    qingduoCancelFeedback: 'qingduoCancelFeedback',
    // 保存并收起
    qingduoSaveAndCloseFeedback: 'qingduoSaveAndCloseFeedback',
    // 截图/本地上传点击 f6:snapshot/upload
    qingduoFeedbackImage: 'qingduoFeedbackImage',
    // 消息中心
    // 消息tab点击：系统消息/我的消息
    messageCenterTab: 'messageCenterTab',
    // 消息内容文本点击
    messageCenterClick: 'messageCenterClick',
    // 消息链接的点击
    messageCenterLinkClick: 'messageCenterLinkClick',
    // 消息中心批量已读
    messageCenterMarkRead: 'messageCenterMarkRead',
    // 消息中心批量删除
    messageCenterDelete: 'messageCenterDelete',
    // 消息中心浮窗曝光时间
    messageCenterPopoverExpose: 'messageCenterPopoverExpose',
    // 消息中心浮窗tab点击：系统消息/我的消息
    messageCenterPopoverTab: 'messageCenterPopoverTab',
    // 消息中心浮窗-忽略全部
    messageCenterMarkIgnore: 'messageCenterMarkIgnore',
    // 消息中心浮窗-查看全部
    messageCenterRedirect: 'messageCenterRedirect',
    // 消息中心浮窗内容文本点击
    messageCenterPopoverClick: 'messageCenterPopoverClick',
    // 消息中心浮窗链接的点击
    messageCenterPopoverLinkClick: 'messageCenterPopoverLinkClick',
    // 关于平台
    // 不同tab查看
    aboutUs: 'aboutUs',
    // 我的订单
    // 订单状态筛选
    orderFilterStatus: 'orderFilterStatus',
    // 订单状态筛选
    orderFilterProductType: 'orderFilterProductType',
    // 订单操作
    orderWriteOff: 'orderWriteOff',
    orderInvoice: 'orderInvoice',
    orderCertification: 'orderCertification',
    // 权益中心
    // 入口
    couponEnter: 'couponEnter',
    // 充值入口点击
    couponPayEnter: 'couponPayEnter',
    // 充值弹窗立即支付
    couponPayDialog: 'couponPayDialog',
    // 充值弹窗底部协议点击
    couponPayDialogProtocol: 'couponPayDialogProtocol',
    // hover查看顶部点券余额
    couponPopover: 'couponPopover',
    // ai混剪相关
    mushupCreate: 'mushupCreate',

    // 文案库
    // 按时间区间筛选
    TextAssetsFilterRange: 'TextAssetsFilterRange',
    // 按推广业务筛选
    TextAssetsFilterBusinessPoint: 'TextAssetsFilterBusinessPoint',
    // 按渠道筛选
    TextAssetsFilterGenerateType: 'TextAssetsFilterGenerateType',
    // 跳转一键生文
    TextAssetsRedirect: 'TextAssetsRedirect',
    // 删除和批量删除
    TextAssetsDelete: 'TextAssetsDelete',
    TextAssetsBatchDelete: 'TextAssetsBatchDelete',

    // 任务中心-文案
    // 任务筛选
    TaskTextFilterGenerateType: 'TaskTextFilterGenerateType',
    TaskTextFilterBusinessPoint: 'TaskTextFilterBusinessPoint',
    TaskTextFilterRange: 'TaskTextFilterRange',
    // 列表-批量保存
    TaskTextBatchSaveTask: 'TaskTextBatchSaveTask',
    // 列表-批量删除
    TaskTextBatchDelete: 'TaskTextBatchDelete',
    TaskTextBatchDeleteCancel: 'TaskTextBatchDeleteCancel',
    // 列表行操作-详情
    TaskTextShowDetail: 'TaskTextShowDetail',
    // 详情页操作-保存
    TaskTextSave: 'TaskTextSave',
    // 详情页操作-编辑
    TaskTextEdit: 'TaskTextEdit',
    // 详情页操作-批量保存
    TaskTextBatchSave: 'TaskTextBatchSave',
    // 列表行操作-保存
    TaskTextSaveTask: 'TaskTextSaveTask',
    // 列表行操作-重新生成
    TaskTextReGenerate: 'TaskTextReGenerate',
    // 列表行操作-删除
    TaskTextDelete: 'TaskTextDelete',
    TaskTextDeleteCancel: 'TaskTextDeleteCancel'
};
